import React from 'react';

import { IndeterminateValue, isIndeterminate, PropertySelectField } from '@paragon/client-tools';

import { getVisibleRoofContainersDictionary } from '../../store/selectors/layoutDataSelectors';
import { useAppSelector } from '../hooks';

export function RoofContainerSelect(props: {
  roofContainerGuid: string | null | IndeterminateValue;
  onChange: (roofContainerGuid: string) => void;
  disabled?: boolean;
}) {
  const roofContainers = useAppSelector(getVisibleRoofContainersDictionary);

  return (
    <PropertySelectField<string>
      margin="normal"
      property="Roof Container"
      disabled={props.disabled}
      allowUnknownValues={isIndeterminate(props.roofContainerGuid)}
      value={props.roofContainerGuid}
      getValue={(roofContainerGuid) => roofContainerGuid}
      getName={(roofContainerGuid) => roofContainers[roofContainerGuid].name}
      options={Object.values(roofContainers).map((container) => container.guid)}
      submit={props.onChange}
    />
  );
}
